<template>
	<div class="skill-config">
		<div class="page-title">
			<span>技能配置</span>
			<el-button size="mini" type="primary" @click="handleAdd" v-if="perms.includes('train:skill:config:add')">新增</el-button>
		</div>
		<div class="content-wrapper">
			<el-table :data="tableData" :row-class-name="tableRowClassName" :header-cell-style="{ color: '#444' }" border style="width: 100%">
				<el-table-column type="expand">
					<template slot-scope="props">
						<el-collapse v-model="props.row.activeName" accordion @change="handleChange(props.row)">
							<el-collapse-item name="1">
								<template slot="title">
									<span>配置包</span>
									<el-button size="mini" type="text" @click.stop="handleBundleAdd(props.row.id)" v-if="perms.includes('train:skill:config:bundle:config')">新增</el-button>
								</template>
								<el-table
									class="config-table"
									row-class-name="row-1"
									:data="props.row.bundles"
									:row-class-name="tableRowClassName"
									:show-header="false">
									<el-table-column label="项目技能" prop="bundleName"></el-table-column>
									<el-table-column label="项目编码" prop="bundleCode"></el-table-column>
									<el-table-column label="信息" align="left">
										<template slot-scope="scope">
											<span>排序值：{{ scope.row.sort }}</span>
										</template>
									</el-table-column>
									<el-table-column label="创建日期" width="160">
										<template slot-scope="scope">
											<span>{{ scope.row.createTime ? $moment(scope.row.createTime).format("YYYY-MM-DD HH:mm:ss") : "" }}</span>
										</template>
									</el-table-column>
									<el-table-column label="创建者" prop="createBy" width="90"></el-table-column>
									<el-table-column label="最后操作日期" width="160">
										<template slot-scope="scope">
											<span>{{ scope.row.updateTime ? $moment(scope.row.updateTime).format("YYYY-MM-DD HH:mm:ss") : "" }}</span>
										</template>
									</el-table-column>
									<el-table-column label="最后操作者" prop="updateBy" width="90"></el-table-column>
									<el-table-column label="操作">
										<template slot-scope="scope">
											<el-button size="mini" type="text" @click="handleBundleConfig(scope.row)" v-if="perms.includes('train:skill:config:bundle:config')">配置</el-button>
											<el-button size="mini" type="text" @click="handleBundleEdit(props.row.id, scope.row)" v-if="perms.includes('train:skill:config:bundle:config')">编辑</el-button>
											<el-button size="mini" type="text" class="delete-text" @click="handleBundleDelete(scope.row)" v-if="perms.includes('train:skill:config:bundle:del')">删除</el-button>
										</template>
									</el-table-column>
								</el-table>
							</el-collapse-item>
							<el-collapse-item name="2">
								<template slot="title">
									评价逻辑
									<div>
										<el-button size="mini" type="text" @click.stop="handleShowName(props.row.id)" v-if="perms.includes('train:skill:config:level:config')">配置显示名</el-button>
										<el-button size="mini" type="text" @click.stop="handleEvaluateAdd(props.row.id, '')" v-if="perms.includes('train:skill:config:level:config')">新增</el-button>
									</div>
								</template>
								<el-table
									class="config-table"
									row-class-name="row-1"
									:data="props.row.evaluates"
									:row-class-name="tableRowClassName"
									:show-header="false">
									<el-table-column label="项目技能" prop="levelName"></el-table-column>
									<el-table-column label="项目编码" prop="levelCode"></el-table-column>
									<el-table-column label="信息">
										<template slot-scope="scope">
											<span>{{ scope.row.level ? `等级：${scope.row.level}` : "" }}</span>
											<br />
											<span v-if="scope.row.showName">显示名：{{ scope.row.showName }}</span>
											<br />
											<span>{{ scope.row.preName ? `前置：${scope.row.preName}` : "" }}</span>
										</template>
									</el-table-column>
									<el-table-column label="创建日期" width="160">
										<template slot-scope="scope">
											<span>{{ scope.row.createTime ? $moment(scope.row.createTime).format("YYYY-MM-DD HH:mm:ss") : "" }}</span>
										</template>
									</el-table-column>
									<el-table-column label="创建者" prop="createBy" width="90"></el-table-column>
									<el-table-column label="最后操作日期" width="160">
										<template slot-scope="scope">
											<span>{{ scope.row.updateTime ? $moment(scope.row.updateTime).format("YYYY-MM-DD HH:mm:ss") : "" }}</span>
										</template>
									</el-table-column>
									<el-table-column label="最后操作者" prop="updateBy" width="90"></el-table-column>
									<el-table-column label="操作">
										<template slot-scope="scope">
											<el-button size="mini" type="text" @click="handleEvaluateConfig(props.row, scope.row)" v-if="perms.includes('train:skill:config:level:config')">配置</el-button>
											<el-button size="mini" type="text" @click="handleEvaluateAdd(props.row.id, scope.row)" v-if="perms.includes('train:skill:config:level:config')">编辑</el-button>
											<el-button size="mini" type="text" class="delete-text" @click="handleEvaluateDelete(scope.row)" v-if="perms.includes('train:skill:config:level:del')">删除</el-button>
										</template>
									</el-table-column>
								</el-table>
							</el-collapse-item>
						</el-collapse>
					</template>
				</el-table-column>
				<el-table-column label="项目技能" prop="skillName"></el-table-column>
				<el-table-column label="项目编码" prop="skillCode"></el-table-column>
				<el-table-column label="信息">
					<template slot-scope="scope">
						<span>
							<span>通信箱转发：{{ scope.row.transferFlag ? "是" : "否" }}</span>
							<br />
							<span>排序值：{{ scope.row.sort }}</span>
						</span>
					</template>
				</el-table-column>
				<el-table-column label="创建日期" width="160">
					<template slot-scope="scope">
						<span>{{ scope.row.createTime ? $moment(scope.row.createTime).format("YYYY-MM-DD HH:mm:ss") : "" }}</span>
					</template>
				</el-table-column>
				<el-table-column label="创建者" prop="createBy" width="90"></el-table-column>
				<el-table-column label="最后操作日期" width="160">
					<template slot-scope="scope">
						<span>{{ scope.row.updateTime ? $moment(scope.row.updateTime).format("YYYY-MM-DD HH:mm:ss") : "" }}</span>
					</template>
				</el-table-column>
				<el-table-column label="最后操作者" prop="updateBy" width="90"></el-table-column>
				<el-table-column label="操作">
					<template slot-scope="scope">
						<el-button type="text" @click="handleUserConfig(scope.row)" v-if="perms.includes('train:skill:config:scopeInfo')">关联用户</el-button>
						<el-button type="text" @click="handleEdit(scope.row)" v-if="perms.includes('train:skill:config:update')">编辑</el-button>
						<el-button type="text" @click="handleBundleExport(scope.row)" v-if="perms.includes('train:skill:config:export')">导出</el-button>
						<el-button type="text" class="delete-text" @click="handleDelete(scope.row)" v-if="perms.includes('train:skill:config:del')">删除</el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>

		<!-- 新增/编辑弹窗 -->
		<SkillConfigDialog ref="skillConfigDialogRef" @getSkillList="getSkillList" />
		<!-- 新增/编辑包 -->
		<BundleDialog ref="bundleDialogRef" @getBundleList="getBundleList" />
		<!-- 课程包配置 -->
		<BundleConfigDialog ref="bundleConfigDialogRef" @refresh="getBundleList" />
		<!-- 关联用户 -->
		<UserConfig ref="userConfigRef" />
		<!-- 评价逻辑 -->
		<EvaluateDialog ref="evaluateDialogRef" @refresh="getEvaluateList" />
		<!-- 评价配置 -->
		<EvaluateConfigDialog ref="evaluateConfigDialogRef" />
		<!-- 显示名配置 -->
		<ShowNameConfigDialog ref="showNameConfigDialogRef" />
	</div>
</template>

<script>
import {
	courseSkillList,
	courseSkillDel,
	courseSkillBundleList,
	courseSkillBundleDel,
	courseSkillLevelList,
	courseSkillLevelDel,
	courseSkillExport
} from "@/api/skill";
import SkillConfigDialog from "./components/SkillConfigDialog.vue";
import BundleDialog from "./components/BundleDialog.vue";
import BundleConfigDialog from "./components/BundleConfigDialog.vue";
import UserConfig from "./components/UserConfig.vue";
import EvaluateDialog from "./components/EvaluateDialog.vue";
import EvaluateConfigDialog from "./components/EvaluateConfigDialog.vue";
import ShowNameConfigDialog from "./components/ShowNameConfigDialog.vue";
export default {
	components: {
		SkillConfigDialog,
		BundleDialog,
		BundleConfigDialog,
		UserConfig,
		EvaluateDialog,
		EvaluateConfigDialog,
		ShowNameConfigDialog,
	},
	data() {
		return {
			tableData: [],
			// 权限
			perms: JSON.parse(window.sessionStorage.getItem('perms')),
		};
	},
	mounted() {
		// 获取列表数据
		this.getSkillList();
	},
	methods: {
		// NO.隔行变色
		tableRowClassName({ row, rowIndex }) {
			if (rowIndex % 2 == 1) {
				return "blue";
			} else {
				return "yellow";
			}
		},
		// 获取技能列表
		getSkillList() {
			courseSkillList({}).then((res) => {
				if (res.code != "0") return this.$message.error(res.msg);
				this.tableData = res.data.map((item) => ({
					...item,
					activeName: "",
					bundles: [],
					evaluates: [],
				}));
			});
		},
		// 新增技能
		handleAdd() {
			this.$refs.skillConfigDialogRef.init();
		},
		// 编辑技能
		handleEdit(row) {
			this.$refs.skillConfigDialogRef.init(row);
		},
		// 删除技能
		handleDelete(row) {
			this.$confirm(`确认删除【${row.skillName}】吗？`, "提示", { type: "warning" }).then(() => {
				this.handleDelApi(courseSkillDel, { id: row.id }, this.getSkillList);
			});
		},
		// 关联用户
		handleUserConfig(row) {
			this.$refs.userConfigRef.init(row.id);
		},
		// 公共删除方法
		handleDelApi(api, params, refreshFn) {
			api(params).then((res) => {
				if (res.code != "0") return this.$message.error(res.msg);
				this.$message.success("删除成功");
				refreshFn();
			});
		},
		// 更新技能数据
		updateSkillData(skillId, key, data) {
			const item = this.tableData.find((t) => t.id == skillId);
			if (item) {
				item[key] = data;
			}
		},
		// 获取配置包列表
		getBundleList(skillId) {
			courseSkillBundleList({ skillId }, true).then((res) => {
				if (res.code != "0") return this.$message.error(res.msg);
				this.updateSkillData(skillId, "bundles", res.data);
			});
		},
		// 展开折叠面板切换
		handleChange({ activeName, id }) {
			if (activeName == "1") this.getBundleList(id);
			if (activeName == "2") this.getEvaluateList(id);
		},
		// 新增配置包
		handleBundleAdd(id) {
			this.$refs.bundleDialogRef.init(id);
		},
		// 编辑配置包
		handleBundleEdit(id, row) {
			this.$refs.bundleDialogRef.init(id, row);
		},
		// 删除配置包
		handleBundleDelete(row) {
			this.$confirm(`确认删除【${row.bundleName}】吗？`, "提示", { type: "warning" }).then(() => {
				this.handleDelApi(courseSkillBundleDel, { id: row.id }, () => this.getBundleList(row.skillId));
			});
		},
		// 课程包导出
		handleBundleExport(row) {
			courseSkillExport({ skillId: row.id }).then((res) => {
				if (res.code == '0') {
					const linkNode = document.createElement('a');
					linkNode.style.display = 'none';
					linkNode.href = res.data;
					document.body.appendChild(linkNode);
					linkNode.click();  //模拟在按钮上的一次鼠标单击
					URL.revokeObjectURL(linkNode.href); // 释放URL 对象
					document.body.removeChild(linkNode);
				} else {
					that.$message.error(res.msg)
				}
			});
		},
		// 课程包配置
		handleBundleConfig(row) {
			this.$refs.bundleConfigDialogRef.init(row);
		},
		// 新增评价逻辑
		handleEvaluateAdd(skillId, row) {
			this.$refs.evaluateDialogRef.init(skillId, row);
		},
		// 新增评价逻辑
		handleShowName(skillId) {
			this.$refs.showNameConfigDialogRef.init(skillId);
		},
		// 获取评价列表
		getEvaluateList(skillId) {
			courseSkillLevelList({ skillId }, true).then((res) => {
				if (res.code != "0") return this.$message.error(res.msg);
				this.updateSkillData(skillId, "evaluates", res.data);
			});
		},
		// 删除评价逻辑
		handleEvaluateDelete(row) {
			this.$confirm(`确认删除【${row.levelName}】吗？`, "提示", { type: "warning" }).then(() => {
				this.handleDelApi(courseSkillLevelDel, { id: row.id }, () => this.getEvaluateList(row.skillId));
			});
		},
		// 评价配置
		handleEvaluateConfig(prow, row) {
			row.skillName = prow.skillName;
			this.$refs.evaluateConfigDialogRef.init(row);
		},
	},
};
</script>

<style lang="scss" scoped>
.skill-config {
	.page-title {
		font-size: 18px;
		font-weight: bold;
		margin-bottom: 20px;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}
	.content-wrapper {
		background: #fff;
	}
}

.el-table {
	width: 100%;
}

.config-table {
	font-size: 13px;
	background-color: #fbfdff;
	width: calc(100% - 48px);
	margin-left: 48px;
}

.el-table--enable-row-transition ::v-deep .el-table__expanded-cell {
	padding: 20px 0;
}

.el-collapse {
	border: none;
}

::v-deep .el-collapse-item__wrap {
	border: none;
}

.el-collapse-item ::v-deep .el-collapse-item__header {
	display: flex;
	justify-content: space-between;
	position: relative;
	padding-left: 58px;
	padding-right: 40px;
	background-color: #f2f9ff;
	margin-left: 48px;
	margin-bottom: 2px;
}
.el-collapse-item ::v-deep .el-collapse-item__arrow {
	position: absolute;
	left: 30px;
	top: 18px;
}

.delete-text {
	color: #f56c6c;
}
</style>
